import { AiPriceAlertSeverityEnum } from '@api/ringil-api.v2.tsx';

export function getSeverityClassName(severity?: AiPriceAlertSeverityEnum) {
  switch (severity) {
    case AiPriceAlertSeverityEnum.SEVERITY_4:
      return 'border-complementary-error bg-complementary-errorLight shadow-[0_0_4px_0_rgba(228,0,43,0.4)]';
    case AiPriceAlertSeverityEnum.SEVERITY_3:
      return 'border-content-brand bg-complementary-brandLight shadow-[0_0_4px_0_rgba(254, 80, 0, 0.4)]';
    case AiPriceAlertSeverityEnum.SEVERITY_2:
      return 'border-complementary-warning bg-complementary-warningLight shadow-[0_0_4px_0_rgba(255, 209, 0, 0.4)]';
    case AiPriceAlertSeverityEnum.SEVERITY_1:
      return 'border-complementary-info bg-complementary-infoLight shadow-[0_0_4px_0_rgba(158, 198, 0, 0.4)]';
    case AiPriceAlertSeverityEnum.SEVERITY_0:
      return 'border-complementary-success bg-complementary-successLight shadow-[0_0_4px_0_rgba(0,198,94,0.4)]';
    default:
      return 'border-content-gr2 bg-content-quaternary shadow-[0_0_4px_0_rgba(0,0,0,0.1)]';
  }
}
